module.exports = __webpack_public_path__ + "static/media/product (6).f1eb99f7.jpg";